import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-full bg-white rounded-xl px-6 pt-6 pb-8 flex flex-col justify-start items-center min-h-52" }
const _hoisted_2 = { class: "w-full flex items-center justify-between" }
const _hoisted_3 = { class: "w-full mt-6" }
const _hoisted_4 = { class: "mb-2" }
const _hoisted_5 = { class: "w-full flex items-center justify-between bg-wrh-green-background py-3 px-4 rounded-lg focus:outline-none focus:ring-2 focus:ring-wrh-green-dark" }
const _hoisted_6 = { class: "flex items-center justify-start space-x-2" }

import { formatDistanceToNow } from 'date-fns';
import MessagesIcon from './icons/MessagesIcon.vue';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const messgTitle = 'My Messages';
const msgLink = 'View All';
const conversationName = 'Jake Williams';
const conversationCount = '2';
const conversationTime = '5h';
const activeHomeId = '123';

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h2", { class: "t-22m text-wrh-blue-dark" }, _toDisplayString(messgTitle)),
      _createVNode(_component_router_link, {
        class: "t-14r text-wrh-blue-light capitalize",
        to: `/homes/${activeHomeId}/messages`
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(msgLink))
        ]),
        _: 1
      }, 8, ["to"])
    ]),
    _createElementVNode("ul", _hoisted_3, [
      _createElementVNode("li", _hoisted_4, [
        _createElementVNode("button", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createVNode(MessagesIcon, { class: "w-5 h-5 text-wrh-green-medium" }),
            _createElementVNode("span", { class: "t-14m text-wrh-gray-dark font-normal" }, _toDisplayString(conversationName))
          ]),
          _createElementVNode("div", { class: "flex items-baseline justify-end space-x-2" }, [
            _createElementVNode("div", null, [
              _createElementVNode("span", { class: "inline-flex items-center t-12m px-2.5 py-0.75 rounded-full bg-wrh-green-medium text-white" }, _toDisplayString(conversationCount))
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("span", { class: "t-12r text-wrh-gray-dark" }, _toDisplayString(conversationTime))
            ])
          ])
        ])
      ])
    ])
  ]))
}
}

})